// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multicolortitle_text__12px__bold__blue__TIzFq {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; 
}

.multicolortitle_title__14px__blue__ZomtX {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__14px__orange__Dk2ax {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_text__16px__blue__a3OTY {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: none;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: auto;
  order: 0;
  flex-grow: 0; }

  
.multicolortitle_text__16px__bold__blue__vb4CV {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: auto;
  order: 0;
  flex-grow: 0; }

.multicolortitle_text__16px__orange__xQCqX {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 50px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__14px__bold__blue__IIZx7 {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__14px__bold__orange__KN\\+W1 {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_text__18px__blue__D\\+rWy {
  /* Futura LT, Regular 18px */
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 200%;
  /* or 36px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  /* HSRC_MidDark */
  color: #415167; }

.multicolortitle_text__18px__bold__blue__8k-4G {
  /* Futura LT, Regular 18px */
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 200%;
  /* or 36px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  /* HSRC_MidDark */
  color: #415167; 
}

.multicolortitle_text__18px__orange__OV\\+pR {
  /* Futura LT, Regular 18px */
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 200%;
  /* or 36px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  /* HSRC_MidDark */
  color: #FF7F50; }

.multicolortitle_text__18px__bold__orange__O0eIB {
  /* Futura LT, Regular 18px */
  font-family: FuturaLT;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 200%;
  /* or 36px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  /* HSRC_MidDark */
  color: #FF7F50; 
} 

.multicolortitle_title__32px__blue__Ic1V3 {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 42px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__32px__orange__IoYyf {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 42px;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__42px__blue__QzIHS {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 42px;
  line-height: 150%;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__42px__orange__Azb53 {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 42px;
  line-height: 150%;
  /* identical to box height, or 63px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_Orange */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

  .multicolortitle_title__42px__bold__orange__5gn0p {
    font-family: FuturaLT;
    font-style: normal;
    font-weight: bold;
    font-size: 42px;
    line-height: 150%;
    /* identical to box height, or 63px */
    display: flex;
    align-items: center;
    letter-spacing: 0.07em;
    text-transform: capitalize;
    /* HSRC_Orange */
    color: #FF7F50;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0; }  

.multicolortitle_title__54px__blue__enRTJ {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 54px;
  line-height: 150%;
  /* identical to box height, or 81px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__54px__orange__f3URQ {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 54px;
  line-height: 150%;
  /* identical to box height, or 81px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__66px__blue__lGjbA {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 66px;
  line-height: 120%;
  /* identical to box height, or 81px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #133454;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }

.multicolortitle_title__66px__orange__WXT25 {
  font-family: FuturaLT;
  font-style: normal;
  font-weight: normal;
  font-size: 66px;
  line-height: 120%;
  /* identical to box height, or 81px */
  display: flex;
  align-items: center;
  letter-spacing: 0.07em;
  text-transform: capitalize;
  /* HSRC_DarkBlue */
  color: #FF7F50;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/MultiColorTitle/multicolortitle.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;;AAGhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc,EAAE;;AAElB;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc,EAAE;;AAElB;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;EAEd;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,UAAU;IACV,QAAQ;IACR,YAAY,EAAE;;AAElB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE;;AAEhB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,YAAY,EAAE","sourcesContent":[".text__12px__bold__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 12px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; \r\n}\r\n\r\n.title__14px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__14px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 14px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.text__16px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 16px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: none;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: auto;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n  \r\n.text__16px__bold__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: auto;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.text__16px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 16px;\r\n  line-height: 50px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__14px__bold__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__14px__bold__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.text__18px__blue {\r\n  /* Futura LT, Regular 18px */\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 18px;\r\n  line-height: 200%;\r\n  /* or 36px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  /* HSRC_MidDark */\r\n  color: #415167; }\r\n\r\n.text__18px__bold__blue {\r\n  /* Futura LT, Regular 18px */\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  line-height: 200%;\r\n  /* or 36px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  /* HSRC_MidDark */\r\n  color: #415167; \r\n}\r\n\r\n.text__18px__orange {\r\n  /* Futura LT, Regular 18px */\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 18px;\r\n  line-height: 200%;\r\n  /* or 36px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  /* HSRC_MidDark */\r\n  color: #FF7F50; }\r\n\r\n.text__18px__bold__orange {\r\n  /* Futura LT, Regular 18px */\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  line-height: 200%;\r\n  /* or 36px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  /* HSRC_MidDark */\r\n  color: #FF7F50; \r\n} \r\n\r\n.title__32px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 32px;\r\n  line-height: 42px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__32px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 32px;\r\n  line-height: 42px;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__42px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 42px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__42px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 42px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 63px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_Orange */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n  .title__42px__bold__orange {\r\n    font-family: FuturaLT;\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    font-size: 42px;\r\n    line-height: 150%;\r\n    /* identical to box height, or 63px */\r\n    display: flex;\r\n    align-items: center;\r\n    letter-spacing: 0.07em;\r\n    text-transform: capitalize;\r\n    /* HSRC_Orange */\r\n    color: #FF7F50;\r\n    /* Inside Auto Layout */\r\n    flex: none;\r\n    order: 0;\r\n    flex-grow: 0; }  \r\n\r\n.title__54px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 54px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 81px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__54px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 54px;\r\n  line-height: 150%;\r\n  /* identical to box height, or 81px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__66px__blue {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 66px;\r\n  line-height: 120%;\r\n  /* identical to box height, or 81px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #133454;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n\r\n.title__66px__orange {\r\n  font-family: FuturaLT;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 66px;\r\n  line-height: 120%;\r\n  /* identical to box height, or 81px */\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: 0.07em;\r\n  text-transform: capitalize;\r\n  /* HSRC_DarkBlue */\r\n  color: #FF7F50;\r\n  /* Inside Auto Layout */\r\n  flex: none;\r\n  order: 0;\r\n  flex-grow: 0; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text__12px__bold__blue": `multicolortitle_text__12px__bold__blue__TIzFq`,
	"title__14px__blue": `multicolortitle_title__14px__blue__ZomtX`,
	"title__14px__orange": `multicolortitle_title__14px__orange__Dk2ax`,
	"text__16px__blue": `multicolortitle_text__16px__blue__a3OTY`,
	"text__16px__bold__blue": `multicolortitle_text__16px__bold__blue__vb4CV`,
	"text__16px__orange": `multicolortitle_text__16px__orange__xQCqX`,
	"title__14px__bold__blue": `multicolortitle_title__14px__bold__blue__IIZx7`,
	"title__14px__bold__orange": `multicolortitle_title__14px__bold__orange__KN+W1`,
	"text__18px__blue": `multicolortitle_text__18px__blue__D+rWy`,
	"text__18px__bold__blue": `multicolortitle_text__18px__bold__blue__8k-4G`,
	"text__18px__orange": `multicolortitle_text__18px__orange__OV+pR`,
	"text__18px__bold__orange": `multicolortitle_text__18px__bold__orange__O0eIB`,
	"title__32px__blue": `multicolortitle_title__32px__blue__Ic1V3`,
	"title__32px__orange": `multicolortitle_title__32px__orange__IoYyf`,
	"title__42px__blue": `multicolortitle_title__42px__blue__QzIHS`,
	"title__42px__orange": `multicolortitle_title__42px__orange__Azb53`,
	"title__42px__bold__orange": `multicolortitle_title__42px__bold__orange__5gn0p`,
	"title__54px__blue": `multicolortitle_title__54px__blue__enRTJ`,
	"title__54px__orange": `multicolortitle_title__54px__orange__f3URQ`,
	"title__66px__blue": `multicolortitle_title__66px__blue__lGjbA`,
	"title__66px__orange": `multicolortitle_title__66px__orange__WXT25`
};
export default ___CSS_LOADER_EXPORT___;
